import { render, staticRenderFns } from "./Sentenciados.vue?vue&type=template&id=bc39ea98&scoped=true&"
import script from "./Sentenciados.vue?vue&type=script&lang=js&"
export * from "./Sentenciados.vue?vue&type=script&lang=js&"
import style0 from "./Sentenciados.vue?vue&type=style&index=0&id=bc39ea98&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc39ea98",
  null
  
)

export default component.exports